<template>
	<div>
		<!--  名校风采-->
		<div class="expert">
			<!-- v-show="$route.meta.showFather" -->
			<Breadcrumb></Breadcrumb>
			<div v-show="$route.meta.showFather">
				<div class="check pad-16">
					<div class="all-check">
						<div class="check-1">
							<p class="check-p">省份({{num}})</p>
							<div class="check-1-p">
								<p :class="showAllSelected?'selected':'delAll'" @click="checkAll">全部</p>
								<p v-for="(ite,inde) in proviceList" :key="inde" @click="proClick(inde)"
									:class="ite.checked?'selected':'delAll'">
									<!-- :class="ite.checked?'selected':'delAll'" -->
									<!-- :class="current == inde ?'selected':'delAll'" -->
									{{ite.provinceName}}
								</p>
							</div>
						</div>
						<div class="check-1 jus-bet" style="margin-bottom: 0;">
							<!-- 							<div class="check-1">
								<p class="check-p">学段({{schoolNo}})</p>
								<div class="check-1-p">
									<p :class="schoolShow?'selected':'delAll'" @click="schoCheckAll">全部</p>
									<p v-for="(ite,inde) in school" :key="inde" @click="schoClick(ite.name,inde)"
										:class="ite.checked?'selected':'delAll'">
										{{ite.name}}
									</p>
								</div>
							</div> -->
							<div></div>
							<div class="check-1 align-1 cursor" @click="again" style="">
								<img src="../../assets/expert/chongzhi.png" alt="" style="width: 16px;height: 16px;">
								<p>重置</p>
							</div>
						</div>
					</div>
				</div>
				<div class="boxshow">
					<div class="experts flex-1 pad-16 jus-bet">
						<div class="flex-1 jus-bet">
							<div class="left-icon"></div>
							<p>名校风采</p>
						</div>
					</div>
					<div class="pad-16 col-22">
						<div class="flex-1 wid-100" style="margin-bottom: 24px;" v-for="(item,index) in expertList"
							:key="index">
							<div class="hed-img">
								<img :src="item.coverImg" alt="">
							</div>
							<!-- <img :src="item.coverImg" alt="" style="width: 280px;margin-right: 20px;" /> -->
							<div class="wid-100" style="padding-right: 48px;width: 640px;">
								<div class="flex-1 just-bet mb-8">
									<p class="name-1">{{item.schoolName}}</p>
									<!-- <img :src="item.img" alt="" class="sex-img"> -->
									<!-- <img src="/src/assets/expert/nv.png" alt=""> -->
								</div>
								<div class="flex-1 just-bet" style="align-items: baseline;">
									<p class="name-2">学校简介:</p>
									<div class="name-3">
										{{item.introduction}}
									</div>
								</div>
							</div>
							<div class="online cursor" @click="detail(item.id)">
								查看详情
							</div>
						</div>
						<el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes"
							:page-size="pageGroup.size" layout="total, sizes, prev, pager, next, jumper"
							:total="pageInline.tableTotal">
						</el-pagination>

						<!-- <router-view :key="$route.fullPath"></router-view> -->
					</div>
				</div>
			</div>
			<router-view></router-view>
		</div>
		<footers v-show="footersType == 0"></footers>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	import city from '@/components/city.json';
	import {
		getTypes
	} from '@/api/expert/api.js';
	import {
		getEliteSchool,
	} from '@/api/famous/api.js';
	export default {
		name: 'school',
		components: {
			Breadcrumb,
			footers
		},
		data() {
			return {
				proviceList: city.data,
				num: 0,
				school: [],
				schoolNo: 0,
				expertList: [],
				currentPage4: 4,
				showAllSelected: true,
				schoolShow: true,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 0, // 默认数据总数
				},
				provinceCodeList: [],
				educationStageList: [],
				seachType: '',
				title: '',
				footersType: 0,
				pageGroup: {
					pageNo: 1,
					size: 10,
				}
			}
		},
		watch: {
			'$root.searchText'(val) {
				this.title = val;
				this.getType();
				this.getInit();
			}
		},
		mounted() {
			this.footersType = this.$route.params.footersType || 0;
			this.seachType = this.$route.params.seachType;
			this.title = this.$route.params.title;
			this.getType();
			this.getInit();
			let newarr1 = [];
			this.proviceList.map((item, index) => {
				newarr1.push(Object.assign(item, {
					checked: false
				}))
			})
			this.proviceList = newarr1;
		},
		methods: {
			getType() {
				getTypes().then(res => {
						let arr1 = [];
						let list = res.data;
						let newarr = [];
						list.map((item, index) => {
							newarr.push(Object.assign(item, {
								checked: false
							}))
						})
						list = newarr;
						list.forEach((item, index) => {
							if (item.type == 1) {
								arr1.push(item)
							}
						})
						this.school = arr1;


					})
					.catch(error => {

					});
			},
			getInit() {
				let params = {
					type: 1,
					pageNo: this.pageGroup.pageNo,
					schoolName: this.title,
					pageSize: this.pageGroup.size,
					provinceCodeList: this.provinceCodeList,
					educationStageList: this.educationStageList,
				}
				getEliteSchool(params).then(res => {
						this.expertList = res.data.list;
						this.pageInline.tableTotal = res.data.total;
					})
					.catch(error => {

					});
			},
			// 省份
			proClick(index) {
				this.proviceList[index].checked = !this.proviceList[index].checked;
				let isSelectedAll = this.proviceList.every((item) => item.checked)
				this.showAllSelected = isSelectedAll
				let data = this.proviceList.filter((item) => item.checked)
				this.num = data.length;
				if (data.length == []) {
					this.showAllSelected = true;
				} else if (data.length < this.proviceList.length) {
					this.showAllSelected = false;
				} else {
					this.showAllSelected = true;
				}
				let arr = []
				data.forEach((item, index) => {
					arr.push(item.provinceCode)
				})
				this.provinceCodeList = arr.join(",")
				this.getInit();
			},
			checkAll() {
				this.showAllSelected = false;
				this.proviceList.forEach((item) => {
					item.checked = this.showAllSelected
				})
				let data = this.proviceList.filter((item) => item.checked)
				this.num = data.length;
				if (data.length == []) {
					this.showAllSelected = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.provinceCode
				//     arr.push(ids)
				// })
				// this.provinceCodeList = arr.join(",");
				this.provinceCodeList = '';
				this.getInit();
				// console.log(this.provinceCodeList,'this.provinceCodeList')
			},
			// 学段
			schoClick(name, index) {
				this.school[index].checked = !this.school[index].checked;
				let isSelectedAll = this.school.every((item) => item.checked)
				this.schoolShow = isSelectedAll
				let data = this.school.filter((item) => item.checked)
				// educationStageList
				// console.log(data, 'data')
				this.schoolNo = data.length;
				if (data.length == []) {
					this.schoolShow = true;
				} else if (data.length < this.school.length) {
					this.schoolShow = false;
				} else {
					this.schoolShow = true;
				}

				let arr = []
				data.forEach((item, index) => {
					let ids = item.id
					arr.push(ids)
				})


				this.educationStageList = arr.join(",");
				this.getInit();
			},
			schoCheckAll() {
				this.schoolShow = false;
				this.school.forEach((item) => {
					item.checked = this.schoolShow
				})
				let data = this.school.filter((item) => item.checked)
				this.schoolNo = data.length;
				if (data.length == []) {
					this.schoolShow = true;
				}
				// let arr = []
				// data.forEach((item, index) => {
				//     let ids = item.id
				//     arr.push(ids)
				// })
				this.educationStageList = '';
				this.getInit();
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageGroup.size = val;
				this.getInit();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageGroup.pageNo = val;
				this.getInit();
			},
			detail(id) {
				this.$router.push({
					name: 'schoolDetail',
					params: {
						id: id
					}
				})
				// this.$router.push('/famous/schoolDetail')
			},
			again() {
				this.checkAll();
				this.schoCheckAll();
				// this.educationStageList = '';
			}

		}
	}
</script>

<style scoped>
	.expert {
		padding: 0 19%;
		/* margin-bottom: 100px; */
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
	}

	.experts {
		margin-top: 16px;

	}

	.experts p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		margin-left: 10px;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
	}

	.check {
		/* width: 100%; */
		/* height: 352px; */
		background: #FAFAFA;
		border-radius: 4px 4px 4px 4px;
		color: #222222;
		margin-top: 16px;
	}

	.check-1 {
		display: flex;
		/* align-items: center; */
		margin-bottom: 16px;
	}

	.check-1 p {
		padding: 4px 12px;
		font-size: 14px;
		font-family: font5;
		white-space: nowrap;
	}

	.check-1-p {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.check-1-p p:first-child {
		/*        color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px; */
	}

	.check-p {
		margin-right: 24px;
		min-width: 74px;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.shouqi {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #666666;
	}

	.col-22 {
		color: #222222;

	}

	.sex-img {
		width: 14px;
		height: 14px;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 1.25rem;
		font-family: font5;
		padding-right: 0.5625rem;
		/* padding-top: 35px; */
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/* autoprefixer: off*/
		-webkit-box-orient: vertical;
		/* autoprefixer: on*/
		-webkit-line-clamp: 3;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}

	.selected {
		color: #3377FF;
		background: #F0F5FF;
		border-radius: 8px 8px 8px 8px;
	}

	.delAll {
		color: #222222;
	}

	.hed-img {
		width: 288px;
		height: 173px;
		margin-right: 30px;
		border-radius: 8px;
		object-fit: fill;
	}

	.hed-img img {
		width: 288px;
		height: 173px;
		border-radius: 8px;
	}
</style>